<template>
	<div>
		<CRow>
			<CCol sm="12">
				<CCard>
					<CCardHeader> Production </CCardHeader>

					<CCardBody>
						<CContainer fluid class="production-container">
							<div class="loader" v-show="isLoading">
								<CSpinner color="info" />
							</div>
							<transition name="fade">
								<CContainer fluid v-show="!isLoading">
									<!-- Step 1 -->
									<CRow v-if="step === 1" alignHorizontal="center" alignVertical="center">
										<CCol>
											<ProductionStartStep
												v-on:prev:step="prevStep()"
												v-on:submit="updateProduction"
											/>
										</CCol>
									</CRow>
									<!-- Step 2 -->
									<CRow v-if="step === 2">
										<CCol>
											<ProductionInProgressStep
												:production="production"
												v-on:goto="goTo"
												v-on:update:production="updateProduction"
												@updateModal="$refs.reader.modalOpen = $event"
											/>
										</CCol>
									</CRow>
								</CContainer>
							</transition>
						</CContainer>
					</CCardBody>
				</CCard>
			</CCol>
		</CRow>
		<ProductionBarcodeReader ref="reader" :production="production" />
	</div>
</template>
<script>
	import ProductionStartStep from './ProductionStartStep';
	import ProductionInProgressStep from './ProductionInProgressStep';
	import ProductionBarcodeReader from './ProductionBarcodeReader';

	export default {
		components: {
			ProductionBarcodeReader,
			ProductionInProgressStep,
			ProductionStartStep,
		},
		data() {
			return {
				step: 1,
				productions: null,
				production: null,
				isLoading: false,
			};
		},
		methods: {
			goTo(step) {
				this.step = step;
			},
			prevStep() {
				this.step--;
			},
			nextStep() {
				this.step++;
			},
			updateProduction(production) {
				this.production = production;

				this.goTo(2);
			},
			error() {
				this.$toast.error(
					"Une erreur s'est produite, certaines fonctionnalitées " +
						'peuvent ne pas fonctionner correctement, contactez un administrateur'
				);
			},
		},
	};
</script>

<style>
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.3s;
	}
	.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
		opacity: 0;
	}

	.production-container {
		min-height: 67vh;
		position: relative;
		display: flex;
	}

	.card-container {
		display: flex;
		flex: 1;
		flex-direction: column;
		justify-content: center;
	}

	.loader {
		position: absolute;
		left: 50%;
		top: 50%;
	}
</style>
